import React, { useState, useEffect, useRef } from 'react';

import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';
import { StepWrapperBox } from '../styledComponent/Boxes.style';
import { AnswerButton } from '../styledComponent/Buttons.style';

interface MeetingCommitmentStepProps extends TitleAndDescriptionProps, StepWizardProps, StepProps {
  approvedMeetingButtonText: string[];
  declineMeetingButtonText: string[];
  failStepId: string;
}

export const MeetingCommitmentStep = (props: MeetingCommitmentStepProps) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [answer, setAnswer] = useState('');
  const [shouldContinue, setShouldContinue] = useState(false);
  const { approvedMeetingButtonText, declineMeetingButtonText, goToNamedStep, failStepId, nextStep, isActive } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isActive) {
      setAnswer('');
      return window.scrollTo(0, 0);
    }
  }, [isActive]);

  const clickedAnswer = (value: string, isContinue: boolean) => {
    setAnswer(value);
    setShouldContinue(isContinue);
    setIsButtonDisabled(false);
  };

  const changeButtonFunction = () => {
    if (!shouldContinue) {
      goToNamedStep(failStepId);
      return;
    }
    nextStep();
  };

  return (
    <>
      {isActive ? (
        <BaseStep {...props} isButtonDisabled={isButtonDisabled} changeButtonFunction={changeButtonFunction}>
          <StepWrapperBox>
            {approvedMeetingButtonText.map((text, index) => (
              <AnswerButton
                // identify element for e2e test
                id={`selectMeetingCommitmentApproved_${index + 1}`}
                key={text}
                ref={buttonRef}
                className={answer === text ? 'active' : ''}
                onClick={() => clickedAnswer(text, true)}
              >
                {text}
              </AnswerButton>
            ))}
            {declineMeetingButtonText.map((text, index) => (
              <AnswerButton
                // identify element for e2e test
                id={`selectMeetingCommitmentDecline_${index + 1}`}
                key={text}
                ref={buttonRef}
                className={answer === text ? 'active' : ''}
                onClick={() => clickedAnswer(text, false)}
              >
                {text}
              </AnswerButton>
            ))}
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
};
